import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "data-properties__title"
};
const _hoisted_2 = {
    key: 0,
    class: "data-properties__label"
};
const _hoisted_3 = { class: "data-properties__value" };
import { onMounted, ref, watch } from 'vue';
import ProductUtils from "../services/ProductUtils";
import ProductAttributeValue from "./ProductAttributeValue.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductAttributeGroup',
    props: {
        group: {},
        product: {},
        variant: {},
        hideTitle: { type: Boolean },
        stacked: { type: Boolean },
        noPropBorders: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const groupLabel = ref(null);
        const classes = ref([]);
        const propClasses = ref([]);
        const attributes = ref([]);
        const omitLabels = ref(false);
        onMounted(init);
        watch(() => props.variant, init);
        function init() {
            const attributesLocal = ProductUtils.mergeAttributes(props.product.master, props.variant);
            attributes.value = attributesLocal.filter(a => a.group && a.group.name === props.group);
            if (!props.hideTitle && attributes.value.length > 0) {
                groupLabel.value = (attributes.value[0].group && attributes.value[0].group.label) || null;
            }
            // If we have just one attribute whose label is the group label, we can omit the attribute label
            omitLabels.value = attributes.value.length === 1 && attributes.value[0].label === groupLabel.value;
            classes.value.push('attribute-group--group-' + props.group);
            if (!groupLabel.value) {
                classes.value.push('attribute-group--no-title');
            }
            if (props.stacked) {
                classes.value.push('data-properties--stacked');
            }
            if (props.noPropBorders) {
                propClasses.value.push('data-properties__property--no-border');
            }
        }
        return (_ctx, _cache) => {
            return (attributes.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["data-properties attribute-group", classes.value])
                }, [
                    (groupLabel.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(groupLabel.value), 1))
                        : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: attr.type,
                            class: _normalizeClass(["data-properties__property", propClasses.value])
                        }, [
                            (!omitLabels.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(attr.label), 1))
                                : _createCommentVNode("", true),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attr.values, (value, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                        (index !== 0)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(", ")
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createVNode(ProductAttributeValue, {
                                            attribute: attr,
                                            value: value,
                                            "value-code": attr.valueCodes[index]
                                        }, null, 8, ["attribute", "value", "value-code"])
                                    ], 64));
                                }), 128))
                            ])
                        ], 2));
                    }), 128))
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
